import React, { useContext, useEffect } from "react";
import { RCLContext } from "../../components/RCL/RCLProvider";
import { Section } from "@sunwing/components";
import { useRouting } from "../../hooks";
import { MyLoyaltyProgramTabs } from "./MyLoyaltyProgramTabs";
import { RCL } from "../../components/RCL";
import { Breadcrumb } from "../../components/Breadcrumb";
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./PlatinumClubVwq.module.scss");
  } else {
    styles = await import("./PlatinumClub.module.scss");
  }
})();

const PlatinumClubPage = () => {
  const { setCurrentRoute } = useRouting();
  const { locale } = useContext(RCLContext);

  useEffect(() => {
    if (setCurrentRoute) {
      setCurrentRoute({
        en: { path: "/en/platinum-cLub" },
        fr: { path: "/fr/platinum-cLub" },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Breadcrumb pageSlug={"platinum-cLub"} locale={locale} />
      <Section
        title={!config.isWestJetMode && RCL({ searchKey: "platinum-club-header" })} 
        as="p"
        titleSize="h1"
        titleAlignment="left"
      >
        {config.isWestJetMode && (<div className={styles.platinumClubHeading}>{RCL({ searchKey: "starheader" })} </div>)}
        {config.isWestJetMode ?(<div style={{ paddingBottom: "56px", backgroundColor: "#F7F7F7"}}> <span>{""} </span></div>) : (<p>
          <RCL searchKey="platinum-club-desc" />
        </p>)}

        <MyLoyaltyProgramTabs />
      </Section>
    </div>
  );
};

export default PlatinumClubPage;
export { PlatinumClubPage };
